module.exports = "<span class=\"tooltip {{ position }}\" [ngClass]=\"{hover:_hover}\">\n  <span class=\"box\">\n    <span class=\"icon large\" [ngClass]=\"icon\"></span>\n    <p>{{ text }}</p>\n  </span>\n  <span class=\"nubbin\"></span>\n</span>\n"


//////////////////
// WEBPACK FOOTER
// ./~/@c4/programming/src/app/common/tooltip/tooltip.directive.html
// module id = 1543
// module chunks = 2